/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesTrendItemDto } from '../../models/sales-trend-item-dto';

export interface DashboardControllerGetSalesTrend$Params {
}

export function dashboardControllerGetSalesTrend(http: HttpClient, rootUrl: string, params?: DashboardControllerGetSalesTrend$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesTrendItemDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardControllerGetSalesTrend.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesTrendItemDto>>;
    })
  );
}

dashboardControllerGetSalesTrend.PATH = '/api/dashboard/sales-trend';
